import MUITextField, { TextFieldProps } from '@mui/material/TextField';
import React from 'react';

import styled from 'styled-components';

const StyledTextField = styled(MUITextField)`
  background-color: #fff;
`;

export const TextField = React.forwardRef((props: TextFieldProps, ref: any) => (
  <StyledTextField id={`${props.label}`} {...props} ref={ref}></StyledTextField>
));

TextField.displayName = 'TextField';
